export const UPLOAD_PROGRESS_EVENT = 'upload-progress'

export type UploadProgressEventDetail =
  | { type: 'start'; total: number; sessionId?: string }
  | { type: 'finalize'; phase: 'idle' | 'pending' | 'complete'; sessionId?: string }
  | { type: 'progress'; id: string; pct: number; sessionId?: string }
  | { type: 'complete'; total: number; failed: number }
  | { type: 'error'; message: string }
  | { type: 'refresh' }

export function dispatchUploadProgressEvent(detail: UploadProgressEventDetail): void {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new CustomEvent(UPLOAD_PROGRESS_EVENT, { detail }))
}
